<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.6875 7V6.1875C5.6875 5.32555 6.02991 4.4989 6.6394 3.8894C7.2489 3.27991 8.07555 2.9375 8.9375 2.9375H10.9688M9.29933 8.625C9.01747 9.11867 8.61008 9.52903 8.11845 9.81445C7.62683 10.0999 7.06847 10.2502 6.5 10.2502C5.93153 10.2502 5.37317 10.0999 4.88155 9.81445C4.38992 9.52903 3.98253 9.11867 3.70067 8.625H1.625C1.40951 8.625 1.20285 8.7106 1.05048 8.86298C0.898102 9.01535 0.8125 9.22201 0.8125 9.4375V11.875C0.8125 12.0905 0.898102 12.2972 1.05048 12.4495C1.20285 12.6019 1.40951 12.6875 1.625 12.6875H11.375C11.5905 12.6875 11.7972 12.6019 11.9495 12.4495C12.1019 12.2972 12.1875 12.0905 12.1875 11.875V9.4375C12.1875 9.22201 12.1019 9.01535 11.9495 8.86298C11.7972 8.7106 11.5905 8.625 11.375 8.625H9.29933Z"
      :stroke="stroke"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.9375 1.3125L10.9688 2.9375L8.9375 4.5625"
      :stroke="stroke"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{
  width?: string | number;
  height?: string | number;
  stroke?: string
}>(), {
  width: 13,
  height: 14,
  stroke: 'currentColor'
});
</script>